import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

import { colors } from 'app/variables';
import Button from 'app/commonComponents/Button';

function FormButton({ label, disabled, style, ...rest }) {
  const { isValid, isSubmitting } = useFormikContext();
  const submitDisabled = !isValid || isSubmitting;
  return (
    <Button
      type="submit"
      color={colors.pacificBlue}
      style={{ width: '100%', ...style }}
      disabled={
        typeof disabled === 'boolean'
          ? disabled
          : typeof disabled === 'function'
          ? disabled(submitDisabled)
          : submitDisabled
      }
      {...rest}
    >
      {label}
    </Button>
  );
}

FormButton.propTypes = {
  label: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
};

export default FormButton;
